import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para atualizar a assinatura

export const atualizarAssinaturaService = async (
  assinaturaId: number,
  tipo: string
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/assinatura/${assinaturaId}`;

    let values = {};

    // Verifica se o tipo é ATIVA, se for altera o status e atualizar data Assinatura e vencimento
    if (tipo === "ATIVA") {
      values = {
        status: "ATIVA",
        dataAssinatura: new Date(),
        dataVencimento: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        ),
      };
    }
    // Verifica se o tipo é desativar, se for altera apenas o active para 0
    if (tipo === "DESATIVAR") {
      values = {
        active: 0,
      };
    }

    try {
      const response = await axios.put(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }
};

export {};
